export const checkCanPostMessage = () => {
  try {
    if (!window) return false;
    let curParentOrigin = window.location.ancestorOrigins?.[0];
    // IE & Firefox没有ancestorOrigins属性，尝试解析document.referrer
    if (!curParentOrigin && document.referrer) {
      curParentOrigin = new URL(document.referrer).origin
    }
    // eslint-disable-next-line no-undef
    const leadPageOrigin = LEAD_PAGE_ORIGIN;
    const isProdNow = !leadPageOrigin.includes("*");
    if (
      window.parent === window ||
      (isProdNow && !leadPageOrigin.includes(curParentOrigin))
    ) {
      return false;
    }
    return true;
  } catch (error) {
    return true
  }
};

/**
 * @param  {Record<string, string>} query
 * @param  {Record<string, string>} extendQuery
 */
export const addIframeQuery = (
  query: Record<string, string>,
  extendQuery: Record<string, string>,
  vm: any
) => {
  if (vm.$displayFormInIframe) {
    return vm.$router.replace({
      name: vm.$route.name,
      query: { ...query, ...extendQuery },
      params: vm.$route.params
    });
  }
};
